import { NotificationPreferences, UpdateNotificationPreferencesDto } from '@shared/core/notification-preferences'
import ms from 'ms'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { NotificationPreferencesService } from 'src/services/notification-preferences.service'

export const GET_NOTIFICATION_PREFERENCES_CACHE_KEY = 'get-notification-preferences'
export const UPDATE_NOTIFICATION_PREFERENCES_CACHE_KEY = 'update-notification-preferences'

export function useNotificationPreferences(
  options?: UseQueryOptions<NotificationPreferences> & { bypassCache?: boolean },
) {
  const handleRetry = useHandleRetry()
  const { bypassCache, ...queryOptions } = options || {}

  return useQuery(
    [GET_NOTIFICATION_PREFERENCES_CACHE_KEY],
    () => NotificationPreferencesService.getNotificationPreferences(),
    {
      staleTime: bypassCache ? 0 : ms('5 minutes'),
      cacheTime: bypassCache ? 0 : undefined,
      retry: handleRetry,
      ...queryOptions,
    },
  )
}

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()
  return useMutation(
    UPDATE_NOTIFICATION_PREFERENCES_CACHE_KEY,
    (dto: UpdateNotificationPreferencesDto) => NotificationPreferencesService.updateNotificationPreferences(dto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_NOTIFICATION_PREFERENCES_CACHE_KEY])
      },
    },
  )
}
